import { useLayoutEffect } from 'react'
import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar'
import Footer1 from '../../components/common/Footer1'
import Hero from './Hero'
import PrivacyPolicy from './PrivacyPolicy'
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop'

const Pricing = () => {
	return (
		<>
			<div>
				<ScrollToTop />
				<LayoutsNavbar />
				<Hero />
				<PrivacyPolicy />
				<Footer1 />
				{/* <Footer /> */}
			</div>
		</>
	)
}

export default Pricing
